const local = {
  CONF_API_URL: `http://localhost:${process.env.ENV_API_PORT ?? 7071}/api`,
  CONF_SELF_URL: `http://localhost:${process.env.ENV_SELF_PORT ?? 3000}`,
  URL_ENCRYPTION_SECRET: "a7ab1904b0d00f4eee4515ef95b2ccc1cdcd2796",
  API_BASE_URL: `https://its-api.mvphealthcare.com/enrollnow-api/`,
  API_SUBSCRIPTION_KEY: "049832fbfc6a40dc944f2367e90cc06e",
  SHOPPING_PAGE_URL: "https://wwwits.mvphealthcare.com/plans/individual-family",
  HOME_PAGE_URL: "https://wwwits.mvphealthcare.com",
  CONTACT_US_URL: "https://wwwits.mvphealthcare.com/contact-us",
  PUBLIC_SITE_API_BASE_URL: "https://wwwits.mvphealthcare.com/api/",
  MEMBER_PAYMENT_URL: "https://dev-my.mvphealthcare.com/members/Express-Pay",
  ENABLE_DONATE_LIFE_FEATURE: true,
  DONATE_LIFE_SUB_URL: "donatelife.ny.gov/log-in/access-registration",
};

const release = {
    CONF_API_URL: '#{CONF_API_URL}#',
    CONF_SELF_URL: '#{CONF_SELF_URL}#',
    URL_ENCRYPTION_SECRET: '#{URL_ENCRYPTION_SECRET}#',
    API_BASE_URL: '#{API_BASE_URL}#',
    API_SUBSCRIPTION_KEY: '#{kv-apimSubscriptionKey}#',
    SHOPPING_PAGE_URL: '#{SHOPPING_PAGE_URL}#',
    HOME_PAGE_URL: '#{HOME_PAGE_URL}#',
    CONTACT_US_URL: '#{CONTACT_US_URL}#',
    PUBLIC_SITE_API_BASE_URL: '#{PUBLIC_SITE_API_BASE_URL}#',
    MEMBER_PAYMENT_URL: '#{MEMBER_PAYMENT_URL}#',
    ENABLE_DONATE_LIFE_FEATURE: '#{ENABLE_DONATE_LIFE_FEATURE}#',
    DONATE_LIFE_SUB_URL: '#{DONATE_LIFE_SUB_URL}#',
};

const configurations:any = {
  production: release,
  test: release,
  development: local,
};

const exportedConfig = configurations[process.env.NODE_ENV || 'development'] || local;

export enum Feature {
  DonateLife = 'ENABLE_DONATE_LIFE_FEATURE',
}

export const isFeatureEnabled = (feature: Feature): boolean => {
  const value = exportedConfig[feature];
  if (typeof value === 'boolean') return value;
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return false;
};

export const isDonateLifeEnabled = (planState: string): boolean => {
  return isFeatureEnabled(Feature.DonateLife) && planState.toLowerCase() === 'new york';
};

export default exportedConfig;